import { graphql } from '@/generated';

export const auditHistoryQuery = graphql(`
  query auditLog(
    $orderBy: [AuditLogOrderBy!]!
    $where: AuditLogBoolExp!
    $limit: Int!
    $offset: Int!
  ) {
    auditLog(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
      id
      action
      createdAt
      entities
      actorType
      data
      aspNetUser {
        userName
      }
    }
    auditLogAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const allUserQuery = graphql(`
  query allUser {
    aspNetUsers(orderBy: { userName: ASC }) {
      sub
      userName
      aspNetUserRoles {
        aspNetRole {
          name
          normalizedName
        }
      }
    }
  }
`);
